import { useRef, useState, useEffect } from "react";
const useStickyDetection = ({ margin = "-1px 0px 0px 0px", threshold = [1] }) => {
  const ref = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    if (!("IntersectionObserver" in window)) {
      setIsSticky(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([event]) => {
        setIsSticky(event.intersectionRatio < 1);
      },
      {
        threshold,
        rootMargin: margin
      }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [margin, threshold]);
  return { ref, isSticky };
};
const useStickyDetection$1 = useStickyDetection;
export {
  useStickyDetection$1 as default
};
